import { shape, array, arrayOf, number, string } from "prop-types"
import { Box } from "@planningcenter/tapestry-react"
import Assignment from "./Assignment"

const AssignmentType = ({ assignmentType, attendees, assignmentAreas }) => {
  const assignments = assignmentAreas
    .filter(assignmentArea => assignmentArea.assignmentTypeId === assignmentType.id)
    .map(assignmentArea => ({
      ...assignmentArea,
      attendeesCount: attendees.filter(a => a.assignmentAreaIds.includes(assignmentArea.id)).length
    }))

  const unassignedCount = attendees.filter(
    attendee => !attendee.assignmentTypeIds.includes(assignmentType.id)
  ).length

  const assignmentPath = `/assignment_types/${assignmentType.id}`

  if (assignments.length === 0) return null

  return (
    <Box marginBottom={2}>
      <h4 className="mb-1 fw-600">{assignmentType.name}</h4>
      {assignments.map(assignment => (
        <Assignment
          key={assignment.id}
          name={assignment.name}
          count={assignment.attendeesCount}
          assignmentPath={`${assignmentPath}/areas/${assignment.id}`}
        />
      ))}

      <Assignment
        name="Unassigned"
        count={unassignedCount}
        assignmentPath={`${assignmentPath}/attendees/unassigned`}
      />
    </Box>
  )
}

AssignmentType.propTypes = {
  assignmentType: shape({
    id: number,
    name: string
  }).isRequired,
  assignmentAreas: arrayOf(
    shape({
      id: number,
      name: string,
      assignmentTypeId: number
    })
  ).isRequired,
  attendees: arrayOf(
    shape({
      assignmentAreaIds: array,
      assignmentTypeIds: array
    })
  ).isRequired
}

export default AssignmentType
